import { render, staticRenderFns } from "./CompetitionsModal.vue?vue&type=template&id=3decc3c8&scoped=true&"
import script from "./CompetitionsModal.vue?vue&type=script&lang=js&"
export * from "./CompetitionsModal.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionsModal.vue?vue&type=style&index=0&id=3decc3c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3decc3c8",
  null
  
)

export default component.exports